import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Calendar, Form } from 'tmt-ui-kit';
import styled from 'styled-components';

moment.tz.setDefault('Asia/Bangkok');

const { QuantityInput, Button, Input: _Input } = Form;

const InputGroup = styled.div`
  max-width: 300px;
  margin: 16px auto;
  text-align: left;
  >p {
    margin: 8px 0;
  }

  ${props => props.grid && `
    display: grid;
    ${props.col && `
      grid-template-columns: repeat(${props.col}, 1fr);
      grid-column-gap: 4px;
    `}
  `}

  @media(max-width: 600px) {
    display: block;
  }
`;

const MainContainer = styled.div`
  text-align: center;
  padding: 20px 10px;
`;

const ContinueP = styled.p`
  margin: 8px 0;
  >a {
    color: ${props => props.theme.lightGray};
    text-decoration: underline;
  }
`;

const Input = styled(_Input)`
  width: 100%;
  &::placeholder {
    color: ${props => props.theme.lightGray};
  }
`;

const Paragraph = styled.p`
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
`;

const CalendarContainer = styled.div`
  border: 1px solid #e2ecf0;
  padding: 16px 0;
  border-radius: 5px;
`;

const Label = styled.p`
  font-weight: 500;
  text-align: center;
`;

const SubmitButton = styled(Button.OrangeButton)`
  width: 160px;
`;

const Col = styled.div`
  width: 100%;
`;

export default class CustomizeTripForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
    maxTravelers: PropTypes.number,
    customizeObj: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      quantity: props.customizeObj.quantity,
      childQuantity: props.customizeObj.childQuantity || 0,
      date: props.customizeObj.selectedDate,
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    const email = this.emailInput.value;
    const mobile = this.mobileInput.value;
    const firstNmae = this.firstNmae.value;
    const lastName = this.lastName.value;
    const { quantity, childQuantity, date } = this.state;
    const momentDate = date.date;
    if (this.props.onSubmit && email && firstNmae && lastName && mobile && quantity + childQuantity > 0 && momentDate) {
      this.props.onSubmit({
        email,
        name: `${firstNmae} ${lastName}`,
        mobile,
        quantity,
        childQuantity,
        trip_date: momentDate.toISOString()
      });
    }
  }

  render() {
    const { maxTravelers = 1, customizeObj } = this.props;
    return (
      <MainContainer>
        <form onSubmit={this.onSubmit}>
          <h3>Need trip customization?</h3>
          <Paragraph>More people in your group than maximum no. of travelers? Enter your contact info for assistance.</Paragraph>
          <InputGroup>
            <Label>Your email</Label>
            <Input
              type="email"
              ref={input => { this.emailInput = input; }}
              required
              placeholder="myemail@example.com"
            />
          </InputGroup>
          <InputGroup grid col={2}>
            <Col>
              <Label>First name</Label>
              <Input
                type="text"
                ref={input => { this.firstNmae = input; }}
                required
                placeholder="First name"
              />
            </Col>
            <Col>
              <Label>Last name</Label>
              <Input
                type="text"
                ref={input => { this.lastName = input; }}
                required
                placeholder="Last name"
              />
            </Col>
          </InputGroup>
          <InputGroup>
            <Label>Your mobile</Label>
            <Input
              type="tel"
              ref={input => { this.mobileInput = input; }}
              required
              placeholder="+66 081 234 5678"
            />
          </InputGroup>
          <InputGroup>
            <Label>Trip date</Label>
            <CalendarContainer>
              <Calendar.SimpleCalendar
                defaultDate={moment(customizeObj.selectedDate)}
                onChange={day => this.setState({ date: day[0] })}
              />
            </CalendarContainer>
          </InputGroup>
          <InputGroup>
            <QuantityInput
              label="Adults"
              min={maxTravelers + 1}
              max={30}
              value={this.state.quantity}
              onChangeCounter={v => this.setState({ quantity: v })}
            />
            <QuantityInput
              label="Children"
              subLabel="Age 2-12"
              min={0}
              max={30}
              value={this.state.childQuantity}
              onChangeCounter={v => this.setState({ childQuantity: v })}
            />
          </InputGroup>
          <div className="action-group">
            <SubmitButton type="submit">Submit</SubmitButton>
            <ContinueP>
              <a onClick={this.props.onClose}>No, thanks</a>
            </ContinueP>
          </div>
        </form>
      </MainContainer>
    );
  }
}
